import React, { useState, useEffect, useRef } from 'react';
import './UXOverview.css';
import BlueSectionDivider from './BlueSectionDivider';
import {Link} from 'react-router-dom';

const numbers = [
  { num: '+20', text: 'INDUSTRY SECTORS' },
  { num: '78', text: 'CUSTOMER NPS SCORE' },
  { num: '99%', text: 'RECOMMENDATION RATE' },
  { num: '+300', text: 'PROJECTS DELIVERED' },
];

const cards = [
  {
    id: 1,
    img: '/icons/web.png',
    title: "IMPROVE USER EXPERIENCE",
    desc: "Fix problems for a more refined and clear customer journey for your customers."
  },
  {
    id: 2,
    img: '/scale.webp',
    title: "BOOST CONVERSIONS",
    desc: "Increase the number of new users, leads, customers and sales."
  },
  {
    id: 3,
    img: '/icons/coins.webp',
    title: "INCREASE USER ENGAGEMENT",
    desc: "Ensure that users’ needs are met by tackling their pain points. Happy users mean more sales!"
  },
  {
    id: 4,
    img: '/calci.webp',
    title: "REDUCE COSTS",
    desc: "Decrease complexity and lower development and support costs."
  }
];

const UXOverview = (props) => {
  const [active, setActive] = useState('solution');
  const cardRefs = useRef([]);
  const headingRef = useRef(null);
  const paraRef = useRef(null);
  const descRef = useRef(null);

  // IDs of sections to track for highlighting
  const sectionsToHighlight = [
    'overview',
    'process',
    'benefits',
    'team',
    'tech-stack',
    'faq',
    'contact-us'
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    [...cardRefs.current, headingRef.current, paraRef.current, descRef.current].forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  // Scroll-based navbar highlight logic
  useEffect(() => {
    const handleScroll = () => {
      const navbarHeight = 60;
      const scrollPosition = window.scrollY + navbarHeight + 20;

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActive(sectionsToHighlight[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // initial call

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = id => {
    setActive(id);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
    <div className="solutions-navbar">
      <div className="container">
        <ul>
          {['overview', 'process', 'benefits', 'team', 'tech-stack', 'faq', 'contact-us'].map(item => (
            <li key={item}>
              <a
                onClick={() => handleClick(item)}
                className={active === item ? 'active' : ''}
              >
                {item.toUpperCase().replace('_', ' ')}
              </a>
            </li>
          ))}
        </ul>
        </div>
      </div>
    <section className="solutions-section" id="overview">
      <div className="container">
      

      <div className="content">
        <div className="numbers-row">
          {numbers.map(n => (
            <div key={n.num} className="number-block">
              <div className="big-num">{n.num}</div>
              <div className="num-text">{n.text}</div>
            </div>
          ))}
        </div>

        <BlueSectionDivider />

        <div className="solutions-header">
          <h2 ref={headingRef} className="fade-in-left">
            Build highly <span className="blue-text"><br/>competitive <br/>products</span>
          </h2>
          <p className="solutions-intro fade-in-right" ref={paraRef}>
            Provide a seamless user experience and grow your business.Discover usability issues and optimize your product.
          </p>
        </div>

        <p className="solutions-description fade-in-left" ref={descRef}>
          
        </p>

        <div className="ux-solutions-cards">
          {cards.map((card, idx) => (
            <div
              key={card.id}
              className="solution-card fade-up"
              ref={el => (cardRefs.current[idx] = el)}
            >
              <img src={card.img} alt="icon" className="card1-icon" />
              <h3>{card.title}</h3>
              <p className="card-desc">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="down-btn">
        <Link to="/industries">
        <button>SEE INDUSTRIES WE WORK IN</button>
        </Link>
      </div>
      </div>
    </section>
    </>
  );
};

export default UXOverview;
